"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _utils = require("@superlogica/foundation/utils");

var chipThemefication = function chipThemefication(primary, type) {
  var theme = {
    normal: {
      borderColor: _tokens.colors.neutral600,
      color: _tokens.colors.neutral950
    },
    hover: {
      borderColor: (0, _utils.parseColor)(primary),
      color: _tokens.colors.neutral950
    },
    checked: {
      borderColor: (0, _utils.parseColor)(primary),
      background: _tokens.colors.ghost0,
      svgColor: (0, _utils.parseColor)(primary)
    },
    disabled: {
      background: _tokens.colors.neutral100,
      borderColor: _tokens.colors.neutral300,
      color: _tokens.colors.neutral300
    }
  };

  if (type === 'radio') {
    theme.checked = {
      borderColor: (0, _utils.parseColor)(primary),
      background: (0, _utils.hoverColor)((0, _utils.parseColor)(primary), 0.35),
      svgColor: _tokens.colors.neutral950
    };
  }

  if (type === 'filter') {
    theme.checked = {
      borderColor: (0, _utils.parseColor)(primary),
      background: _tokens.colors.ghost0,
      svgColor: _tokens.colors.neutral950
    };
  }

  return theme;
};

var _default = chipThemefication;
exports.default = _default;